import { AnyObjectSchema, ValidationError } from 'yup';
import { useCallback } from 'react';

export const useYupValidationResolver = (validationSchema: AnyObjectSchema) => {
  return useCallback(
    async (data) => {
      try {
        const values = await validationSchema.validate(data, {
          abortEarly: false,
        });

        return {
          values,
          errors: {},
        };
      } catch (errors: any) {
        return {
          values: {},
          errors: errors.inner.reduce(
            (allErrors: ValidationError[], currentError: ValidationError) => ({
              ...allErrors,
              [`${currentError.path}`]: {
                type: currentError.type ?? 'validation',
                message: currentError.message,
              },
            }),
            {},
          ),
        };
      }
    },
    [validationSchema],
  );
};
